import { useContext } from 'react';
import { Box, Modal, ModalContext, Text } from 'dash-ui';
import { useDeleteMediaFileByIdMutation } from 'gql/generated.graphql';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

const RemoveMediaFileModal = () => {
  const theme = useTheme();
  const { t } = useTranslation(['common']);
  const { isOpenCurrent, toggleModal, setPayload, payload } =
    useContext(ModalContext);
  const isOpen = !!isOpenCurrent['RemoveMediaFileModal'];
  const [file] = payload?.media?.files || [];
  const [deleteFile, { loading }] = useDeleteMediaFileByIdMutation();

  const onModalClose = () => {
    toggleModal(false, 'RemoveMediaFileModal');
    setPayload(null);
  };

  const onSubmitModal = () => {
    deleteFile({
      variables: { mediaId: payload?.media._id },
      onCompleted: onModalClose,
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onModalClose}
      title={t('pages:propertyPage.deleteFileModalTitle') || ''}
      cancelButton={{ title: t('common:labels.cancel'), onClick: onModalClose }}
      submitButton={{
        title: t('common:labels.confirm'),
        isLoading: loading,
        disabled: loading,
        onClick: onSubmitModal,
      }}
    >
      <Box py={6}>
        <Text color={theme.colors.n80}>
          {t('pages:propertyPage.deleteFileModalPlaceholder', {
            fileName: file?.name,
          })}
        </Text>
      </Box>
    </Modal>
  );
};

export default RemoveMediaFileModal;
